export default __webpack_public_path__ + "static/media/health-symptoms-active.d95650a7.svg";